var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watcher-logs-chart"},[(_vm.loader)?_c('div',{staticClass:"text-center"},[_c('Loader',{attrs:{"size":'big'}})],1):[_c('LineChartGenerator',{attrs:{"chart-options":{
          responsive: true,
          maintainAspectRatio: false
      },"chart-data":_vm.chartData,"chart-id":"chart","dataset-id-key":"label","height":350}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }